module.exports = __webpack_public_path__ + "static/img/arthroscopy-22.35fbe78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-22.jpg
// module id = MZM2
// module chunks = 52